import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import MyButton from '../components/buttons'
import { API_BASE_URL, WEBSITE_URL } from '../../services/api'
import { useTranslation } from 'react-i18next'
import { CheckCircle2, XCircle, LogIn } from 'lucide-react'

const ConfirmEmail: React.FC = () => {
  const { t } = useTranslation()
  const { token } = useParams<{ token: string }>()
  const [message, setMessage] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        await axios.patch(`${API_BASE_URL}/confirm-email/${token}`)
        setIsSuccess(true)
        setMessage('Votre compte a été confirmé avec succès.')
      } catch (error) {
        setIsSuccess(false)
        setMessage('Le lien de confirmation est invalide ou a expiré.')
      } finally {
        setIsLoading(false)
      }
    }

    confirmEmail()
  }, [token])

  const handleLoginRedirect = () => {
    navigate('/login')
  }

  return (
    <div className='min-h-screen flex items-center justify-center p-4 bg-gray-50'>
      <div className='w-full max-w-md'>
        <div className='p-6'>
          <img
            src='/images/logos/logo-sexagogo-redblack.png'
            alt='logo'
            className='h-16 sm:h-20 mx-auto'
          />
        </div>
        <div className='text-center bg-white rounded-lg shadow-lg overflow-hidden'>
          <div className='bg-anthracite text-white p-4'>
            <h1 className='text-lg sm:text-xl font-medium'>
              {t('email-confirmation')}
            </h1>
          </div>

          <div className='p-6'>
            {isLoading ? (
              <div className='flex flex-col items-center space-y-4'>
                <div className='w-8 h-8 border-4 border-redpink border-t-transparent rounded-full animate-spin'></div>
                <p className='text-gray-600'>{t('verification-in-progress')}</p>
              </div>
            ) : (
              <div className='space-y-2 text-center'>
                <div className='flex justify-center'>
                  {isSuccess ? (
                    <CheckCircle2 className='w-10 h-10 text-green-500' />
                  ) : (
                    <XCircle className='w-10 h-10 text-red-500' />
                  )}
                </div>

                <div
                  className={`p-4 rounded-lg ${
                    isSuccess ? 'bg-green-50' : 'bg-red-50'
                  }`}
                >
                  <p
                    className={`text-sm sm:text-base ${
                      isSuccess ? 'text-green-800' : 'text-red-800'
                    }`}
                  >
                    {message}
                  </p>
                </div>

                {isSuccess && (
                  <div className='text-gray-600 text-sm'>
                    <p>{t('email-confirmed-description')}</p>
                    <p className='mt-2'>{t('click-login-to-continue')}</p>
                  </div>
                )}

                <div className='pt-0 flex justify-center'>
                  <MyButton
                    variant='redpink-anthracite'
                    onClick={handleLoginRedirect}
                    className='w-full sm:w-auto flex items-center justify-center gap-2'
                  >
                    <LogIn className='w-4 h-4' />
                    {t('login')}
                  </MyButton>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmEmail
